import api from './api';
import type { AgreementType } from '../legal';

interface AcceptancePayload {
  agreement_type: AgreementType;
  version: string;
  document_hash?: string;
}

interface AcceptRequest {
  acceptances: AcceptancePayload[];
  email?: string;
  session_token?: string;
  locale?: string;
}

export const agreementApi = {
  /**
   * Record click-wrap acceptance. May be called pre-login (with email +
   * session_token) or post-login (auth token attaches via interceptor).
   */
  async accept(payload: AcceptRequest): Promise<void> {
    await api.post('/agreements/accept', payload);
  },

  /**
   * Authenticated — fetch the user's current acceptance status per type.
   * Returns whether the latest accepted version matches the published version.
   */
  async getMyAcceptances() {
    const response = await api.get('/agreements/me');
    return response.data;
  },

  /**
   * Public — fetch the currently published version metadata. Useful for
   * cross-checking the bundled content against what the server expects.
   */
  async getCurrent() {
    const response = await api.get('/agreements/current');
    return response.data;
  },
};

export default agreementApi;
